<template>
  <dashboard-block
    title="За всё время"
    :min-height="168"
  >
    <v-row>
      <v-col
        v-for="counter in counters"
        :key="counter.title"
        cols="12"
        sm="6"
        class="d-flex align-center"
      >
        <v-avatar
          size="44"
          :color="counter.color"
          rounded
          class="elevation-1"
        >
          <v-icon
            dark
            color="white"
            size="30"
          >
            {{ counter.icon }}
          </v-icon>
        </v-avatar>

        <div class="ms-3">
          <p class="text-xs mb-0">
            {{ counter.title }}
          </p>
          <h3 class="text-xl font-weight-bold">
            {{ counter.value }}
          </h3>
        </div>
      </v-col>
    </v-row>
  </dashboard-block>
</template>

<script>
import {
  mdiTrendingUp, mdiAccountOutline, mdiLabelOutline, mdiCurrencyUsd,
} from '@mdi/js'
import { mapActions, mapState } from 'vuex'
import DashboardBlock from '@/views/dashboard/dashboard-block'
import { money } from '@/helpers'
import { toCountString } from '@/helpers/dashboard'

export default {
  name: 'DashboardStatisticsCard',
  components: { DashboardBlock },
  computed: {
    ...mapState('reportStatistics', ['customerCount', 'totalSales', 'dishCount', 'averageChequeSum', 'loaded']),
    counters() {
      const shown = (value, format) => (this.loaded ? format(value) : '—')

      return [
        {
          title: 'Продажи', value: shown(this.totalSales, money), icon: mdiTrendingUp, color: 'primary',
        },
        {
          title: 'Клиенты', value: shown(this.customerCount, toCountString), icon: mdiAccountOutline, color: 'success',
        },
        {
          title: 'Товары в меню', value: shown(this.dishCount, toCountString), icon: mdiLabelOutline, color: 'warning',
        },
        {
          title: 'Средняя сумма заказа', value: shown(this.averageChequeSum, money), icon: mdiCurrencyUsd, color: 'info',
        },
      ]
    },
  },
  async created() {
    await this.fetch()
  },
  methods: {
    ...mapActions('reportStatistics', ['fetch']),
  },
}
</script>
